import React, { SVGProps } from 'react'
const SvgThumbsUp = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={14}
    height={14}
    aria-hidden="true"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_117_451)">
      <path
        d="M4.08317 12.8333V6.41666M1.1665 7.58332V11.6667C1.1665 12.311 1.68884 12.8333 2.33317 12.8333H10.1651C11.0289 12.8333 11.7635 12.2031 11.8948 11.3494L12.523 7.26609C12.6861 6.20601 11.8659 5.24999 10.7934 5.24999H8.74984C8.42767 5.24999 8.1665 4.98882 8.1665 4.66666V2.60506C8.1665 1.81065 7.52251 1.16666 6.7281 1.16666C6.53862 1.16666 6.36691 1.27825 6.28995 1.45139L4.23713 6.07024C4.14351 6.2809 3.9346 6.41666 3.70408 6.41666H2.33317C1.68884 6.41666 1.1665 6.93899 1.1665 7.58332Z"
        stroke={props.stroke || '#4F3FDD'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_117_451">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgThumbsUp
